import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";
import featureFlags from "utils/featureFlags";

export const MiniTileContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 312px;
  height: 168px;
`;

export const Title = styled.h3`
  color: ${colours.elexonBlue};
  font-size: ${fonts.xLarge};
`;

export const Text = styled.p`
  color: ${colours.darkGrey};
  margin: 0;
  width: 75%;
  text-align: center;
`;

export const StyledChild = styled.div`
  border: 3px solid ${colours.lightGrey};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  text-align: center;
  max-width: 16em;
  justify-content: center;

  h3 {
    color: ${featureFlags.rebrand ? colours.elexonBlue : colours.elexonGreen};
    font-size: ${fonts.xLarge};
    margin: 0.2em 0 0 0;
  }

  p {
    color: ${colours.darkGrey};
    margin: 0.5em 1em 1.5em 1em;
  }
`;
